import * as vp from 'vopay';
import { useEffect, useState } from 'react';
import axios from 'axios';

import { useDataFetchIndicator } from '..';

import vopayApi from '../../services/api.config';

type HookProps = { api: vp.Api };
type HookTuple = [
  response: vp.ScheduledEftFundResponse,
  ScheduledEftFund: (params: vp.ScheduledEftFundRequest) => void,
  reset: () => void,
  ScheduledEftFundAsync: (params: vp.ScheduledEftFundRequest) => Promise<vp.ScheduledEftFundResponse>,
];
type ApiHook = (props: HookProps) => HookTuple;

const usePostScheduledEftFund: ApiHook = ({ api }) => {
  const [, setDataFetchingInfo] = useDataFetchIndicator();
  const [shouldScheduledEftFund, setShouldScheduledEftFund] = useState(false);
  const source = axios.CancelToken.source();
  const [params, setParams] = useState<vp.ScheduledEftFundRequest>({
    PortalUser: '',
    Amount: 0,
    Frequency: '',
    NameOfFrequency: undefined,
    ScheduleStartDate: '',
    ScheduleEndDate: '',
    EndingAfterPayments: '',
    Description: '',
    AccountNumber: '',
    FinancialInstitutionNumber: '',
    BranchTransitNumber: '',
    ClientAccountID: '',
    SemiMonthlyFrequencyType: '',
    FirstName: '',
    LastName: '',
    CompanyName: '',
    DOB: '',
    PhoneNumber: '',
    Address1: '',
    City: '',
    Province: '',
    Country: '',
    PostalCode: '',
    ClientReferenceNumber: '',
    KYCPerformed: false,
    KYCReferenceNumber: '',
    EmailAddress: '',
    IPAddress: '',
    FlinksAccountID: '',
    FlinksLoginID: '',
    Token: '',
    PlaidPublicToken: '',
    PlaidAccessToken: '',
    PlaidAccountID: '',
    PlaidProcessorToken: '',
    InveriteRequestGUID: '',
    DelayBankingInfo: false,
    IdempotencyKey: '',
  });
  const [response, setResponse] = useState<vp.ScheduledEftFundResponse>({
    Success: false,
    ErrorMessage: '',
    Amount: 0,
    ScheduledTransactionID: '',
    Frequency: '',
    Description: '',
    ScheduleStartDate: '',
    Status: '',
  });

  useEffect(() => {
    if (!shouldScheduledEftFund) return () => {};

    const PostScheduledEftFund = async () => {
      setDataFetchingInfo(true, 'processing', 'fullScreen');
      const res = await api.postScheduledEftFund(params, source);
      setResponse(res);
      setDataFetchingInfo(false);
    };

    if (shouldScheduledEftFund) void PostScheduledEftFund();
    setShouldScheduledEftFund(false);
    return () => {
      source.cancel();
    };
  }, [shouldScheduledEftFund]);

  return [
    response,
    (_params: vp.ScheduledEftFundRequest) => {
      setParams(_params);
      setShouldScheduledEftFund(true);
    },
    () => {
      setResponse({
        Success: false,
        ErrorMessage: '',
        Amount: 0,
        ScheduledTransactionID: '',
        Frequency: '',
        Description: '',
        ScheduleStartDate: '',
        Status: '',
      });
      setShouldScheduledEftFund(false);
    },
    async (params: vp.ScheduledEftFundRequest) => {
      return api.postScheduledEftFund(params, source);
    },
  ];
};

export default vopayApi.withApiHook<HookProps, HookTuple>(usePostScheduledEftFund);
